import { render, staticRenderFns } from "./PendingRenewals.vue?vue&type=template&id=1438ad98&"
import script from "./PendingRenewals.vue?vue&type=script&lang=js&"
export * from "./PendingRenewals.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/viewclients.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports